/**
 * ScamBlocker AI — Auth API
 */

import apiClient from '@/shared/lib/api/client';
import { API } from '@/shared/lib/api/endpoints';
import type {
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  RegisterResponse,
} from '@/shared/lib/api/types';

export async function loginApi(data: LoginRequest): Promise<LoginResponse> {
  const res = await apiClient.post<LoginResponse>(API.org.login, data);
  return res.data;
}

export async function logoutApi(refreshToken: string): Promise<void> {
  await apiClient.post(API.org.logout, { refresh_token: refreshToken });
}

export async function registerApi(data: RegisterRequest): Promise<RegisterResponse> {
  const res = await apiClient.post<RegisterResponse>(API.org.register, data);
  return res.data;
}
